import React, { useContext, useEffect } from 'react';

import { AlertContext } from 'fr-shared/context';

import { Button } from 'portal/components';

const useUnverifiedAlert = () => {
  const { setAlert } = useContext(AlertContext);

  useEffect(() => {
    setAlert({
      color: 'primary',
      autoClose: false,
      message: (
        <span>
          <Button
            to={{ pathname: 'https://app.sybridge.com' }}
            color="link"
            openNewWindowWithReferrer
            openNewWindowIcon
          >
            <b> Try SyBridge On-Demand now with a special discount using code: WELCOME10 </b>
          </Button>
        </span>
      ),
    });
  }, [setAlert]);
};

export default useUnverifiedAlert;
